
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TourDetail from "../pages/tour-detail/page";
import FaqPage from "../pages/faq/page";
import RefundPolicyPage from "../pages/refund-policy/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/tour/:slug",
    element: <TourDetail />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/refund-policy",
    element: <RefundPolicyPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
